import { compose } from '@reduxjs/toolkit';
import { fetchAllCustomersReducer } from './fetchAllCustomers';

export const extraReducers = compose(fetchAllCustomersReducer);
export { fetchAllCustomers } from './fetchAllCustomers';
